import AudioManager from "../../Shared/AudioManager";
import UIManager from "../../Shared/UIManager";
import Utils from "../../Shared/Utils";
import NetworkLogic from "../../Shared/NetworkLogic";
import { Global } from "../../Shared/Global";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class NewClass extends cc.Component {

    @property(cc.Label)
    labHttp: cc.Label = null;
    @property(cc.Button)
    btnSubmit: cc.Button = null;

    strUrl = null;

    start() {
        //cc.game.on(cc.game.EVENT_SHOW, this.onGameShow, this)
    }


    updateUI(list) {
        this.labHttp.string = i18n.t('Task.update_video');
        this.btnSubmit.clickEvents[0].customEventData = list.id;
    }

    onBtnClose(event, param) {
        AudioManager.playSound("close");

        this.node.active = false;
    }

    onBtnUpload(event, param) {
        Utils.pickImageFromAlbum("video", function (path: string) {
            cc.log("=====打开视频的path", path);
            cc.log(path);
            let sts = path.split("/");
            let fileName = sts[sts.length - 1];
            let size = jsb.fileUtils.getFileSize(path);
            if (size > 1024 * 1024 * 2) {
                UIManager.hideLoadingUI();
                UIManager.showToastUI(i18n.t('Task.video_limit_size'));
                return;
            }

            UIManager.showLoadingUI();
            NetworkLogic.uploadFile(fileName, jsb.fileUtils.getDataFromFile(path), function (rec) {
                console.log("=====上传视频之后返回", rec);
                UIManager.hideLoadingUI();
                this.strUrl = rec.path;
                this.labHttp.string = this.strUrl;
            }.bind(this), function () {
                UIManager.hideLoadingUI();
                cc.log("====照片视频错误");
            }.bind(this))

        }.bind(this));

    }

    onBtnSubmit(event, param) {
        AudioManager.playSound("button");
        if (!this.strUrl) {
            UIManager.showToastUI(i18n.t('datum_text.msg_update_data'));
            return;
        }
        let data2 = {
            friendUserId: "",
            taskId: param,
            imageUrl: "",
            videoUrl: this.strUrl
        }
        UIManager.showLoadingUI();
        NetworkLogic.agentApplicationReward(data2, function (rec) {
            UIManager.hideLoadingUI();
            cc.log("==== 提交视频资料成功 param：", parseInt(param));
            //cc.director.emit(Global.UserEvent.UpdateShareTaskBtn,parseInt(param));
            this.node.active = false;
            UIManager.showTipUI(i18n.t('datum_text.apply_succ'));
        }.bind(this), function () {
            console.log("=====提交错误")
        })
    }

}
